import React from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import UserDetails from "../components/user-profile-lite/UserDetails";
import UserAccountDetails from "../components/user-profile-lite/UserAccountDetails";
import QSortSorting from "../components/qsortsettings/qSortSorting";


import desktopImage from '../assets/images/background-blobs.png';
import mobileImage from '../assets/images/background-blobs.png';


const imageUrl = window.innerWidth >= 650 ? desktopImage : mobileImage;
const qSortSorting = (props) => (
  <Container fluid className="main-content-container px-4 modal-background"  style={{backgroundImage: `url(${imageUrl})` }}>
      {/* 
    <Row noGutters className="page-header py-4">
      <PageTitle title="Instellingen" subtitle="Q-sort" md="12" className="ml-sm-auto mr-sm-auto" />
    </Row>
    */}

    <QSortSorting qsortdata={props.location.state}/>
    
  </Container>
);

export default qSortSorting;
